import React from 'react';

import { TypographyTable } from '../index';

const metricValues = [
	{
		previewText: 'Aa',
		tokenName: 'font.metric.large',
		fontSize: '28px',
		lineHeight: '32px',
		fontWeight: 653,
	},
	{
		previewText: 'Aa',
		tokenName: 'font.metric.medium',
		fontSize: '24px',
		lineHeight: '28px',
		fontWeight: 653,
	},
	{
		previewText: 'Aa',
		tokenName: 'font.metric.small',
		fontSize: '16px',
		lineHeight: '20px',
		fontWeight: 653,
	},
];

/**
 * __Typography metric table__
 */
export const TypographyMetricTable = () => {
	return (
		<TypographyTable
			values={metricValues}
			typographyTheme="typography-modernized"
			testId="typography-metric-table-modernized"
		/>
	);
};
